import { ButtonProps, IconButton } from '@material-ui/core';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import React from 'react';
import { createEmptyHeader } from 'framework/table/createEmptyHeader';
import { IHeader } from 'framework/table/IHeader';

export const createEditHeader = <T extends unknown>(
	onClick: (val: T) => void,
	disabledF: (val: T) => boolean = (val: T) => false,
	onlyShowOnHover: boolean = false
): IHeader<T> => {
	return createEmptyHeader<T>(
		'select-header',
		t => (
			<ButtonX
				onClick={() => onClick(t)}
				disabled={disabledF(t)}
			/>
		),
		'right',
		onlyShowOnHover
	);
};

const ButtonX = ({ children, ...props }: ButtonProps) => {
	return (
		<IconButton
			{...props}
			size='small'
			color='primary'>
			<EditOutlinedIcon />
		</IconButton>
	);
};
